import React from 'react';
import PropTypes from 'prop-types';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { errorHandler } from './utils';

export const WithIMARepository = ({
  WrappedComponent, i18n, ...others
}) => (
  <CampaignOData
    call={({ currentAccount }) => currentAccount.Audiences.get({
      orderby: [['Name', 'desc']],
      audiencetype: 'InMarket',
      deliverychannel: 'BingAds,AIM',
      top: 1000,
    })
    }
    escapeHatch={({ currentAccount }) => (currentAccount ? undefined : null)}
    fallback={(<WrappedComponent audiences={{ dataNotReady: true }} i18n={i18n} {...others} />)}
    onError={errorHandler(WrappedComponent, i18n)}
  >
    { audiences =>
      (<WrappedComponent audiences={audiences} i18n={i18n} {...others} />) }
  </CampaignOData>
);

WithIMARepository.propTypes = {
  WrappedComponent: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
